<script setup>
    import ModalFactory from '@/views/chat/components/Modal/ModalFactory'
    import useChat from '@/composables/chat/useChat'
    
    const data = useChat.data.modal
    
    function closeModal() {
        data.show = false
    }
</script>

<template>
    <ModalFactory
        :open="data.show"
        :title="data.title"
        :fixed="data.fixed"
        @close-modal="closeModal"
    >
        <Component
            :is="data.component"
            @close-modal="closeModal"
        />
    </ModalFactory>
</template>